import { EntityState } from "@ngrx/entity";

import { CompanyEntity } from '../entities';

export interface CompanyState extends EntityState<CompanyEntity> {
    selectedId: number,
    currentUserCompanyId: number,
    isSearching: boolean,
    isSearched: boolean,
    createCompanyDomain: string
}